import React, { useEffect } from "react"
import { Box } from "src/UILibrary"
import { TopMenuItem } from "./components/TopMenuItem"
import { MenuLayout } from "./components/MenuLayout"
import "src/styles/common.scss"
import { useLoginContext } from "src/hooks/useLoginContext"
import { useNavigate } from "react-router-dom"
import { MEMBER_TYPE, MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { useMediaQuery } from "react-responsive"

interface Props {
  mainIndex: number
  subIndex: number
}
export const MyPage = ({ mainIndex, subIndex }: Props) => {
  const { loggedin, initialized, userType } = useLoginContext()
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const navigate = useNavigate()

  useEffect(() => {
    if (!initialized) {
      return
    }

    if (!loggedin) {
      navigate("/")
    }
  }, [initialized, loggedin])

  return (
    <>
      <Box sx={{ width: "100%" }} className="main-body">
        {isTablet ? (
          <Box display="flex" sx={{ height: "60px" }}>
            <TopMenuItem />
          </Box>
        ) : (
          <></>
        )}
        <Box display="flex">
          {userType === MEMBER_TYPE.COMPANY ? (
            <MenuLayout
              mainMenuIndex={MENU_TYPE.REGISTER_INFORMATION}
              subMenuIndex={SUB_MENU_TYPE.REGISTER_INFO_CHANGE}
            />
          ) : (
            <MenuLayout mainMenuIndex={mainIndex} subMenuIndex={subIndex} />
          )}
        </Box>
      </Box>
    </>
  )
}
